import React from "react";
import TravelPlan from "@/components/TravelPlan";

export default function TravelPlanPage() {
  return (
    <div data-testid="travel-plan-page">
      <TravelPlan title="Seyahat Planı — Tüm Komiteler" />
    </div>
  );
}
